export const red = '#a10204';

export const grayDark = '';

export const green = '';

export const seaweed = '#1b2d15';

export const yellow = '#fff23e';
